import _ from 'lodash'
import { Box, Grid, Paper, Skeleton, Typography } from '@mui/material'
import React from 'react'
import BodyHeader from '../molecules/BodyHeader'
import Figures from '../molecules/Figures'
import TitleSubtitle from '../molecules/TitleSubtitle'
import Zone from '../organisms/Zone'
import chairSun from '../../media/chair-sun.svg'

import strips from '../../media/strips.svg'
import Filtering from '../molecules/Filtering'
import WorkshopCard from '../molecules/WorkshopCard'
import Button from '../atoms/Button'
import useRecoveryWorks from '../../hooks/useRecoveryWorks'
import { APP_BASE_URL, CATEGORIES, DIARY_URL } from '../../constants'
import Slide from '../molecules/Slide'

import useFigures from '../../hooks/useFigures'
import useAtelier from '../../hooks/useAtelier'
import { useLocation } from 'react-router-dom'
import useRemark from '../../hooks/useRemark'

const RecoveryWorkshop = () => {
	const { hash } = useLocation()
	const filterName = hash && hash.split('#')[1]
	const { isLoading, title, content } = useRecoveryWorks()
	const { figures } = useFigures(CATEGORIES.FIGURES.ATELIER.id)
	const { ateliers } = useAtelier()

	const ateliersFiltering =
		(filterName && _.filter(ateliers, ({ categoryName }) => categoryName === filterName)) ||
		ateliers

	const PER_PAGE = 5
	const { remarks } = useRemark(CATEGORIES.COMMENTS.ATELIER.id, PER_PAGE)

	// const { ateliers } = useAtelier(
	// 	filterName && _.find(CATEGORIES.ATELIER, ({ name }) => name === filterName)?.id,
	// )

	return (
		<>
			{(isLoading && <Skeleton />) || (
				<BodyHeader
					title={title}
					buttonLabel="Voir le programme des ateliers"
					buttonHref={`${APP_BASE_URL}${DIARY_URL}`}
				>
					{content}
				</BodyHeader>
			)}

			{ateliersFiltering && (
				<Zone color="ivory">
					<TitleSubtitle
						title="Ateliers récup’"
						subtitle="Apprenez nos techniques de revalorisation et prenez plaisir à faire vous-même"
					/>
					<Typography
						sx={(theme) => ({
							fontSize: 18,
							fontWeight: 400,
							color: 'black',
							mt: 2,
							mx: 40,
							[theme.breakpoints.down('md')]: {
								mx: 0,
							},
						})}
					>
						Nos programmes d’atelier changent régulièrement ! Découvrez nos ateliers phares et
						accédez au programme des ateliers directement sur le site d’HelloAsso.
					</Typography>
					<Box
						sx={(theme) => ({
							display: 'flex',
							justifyContent: 'center',
							m: (theme) => theme.spacing(8, 9.5, 2),
							[theme.breakpoints.down('md')]: {
								mx: 0,
							},
						})}
					>
						<Filtering
							label="Filtrer par catégorie d’atelier"
							list={ateliers}
							filterName={filterName}
						/>
					</Box>
					<Grid
						container
						sx={(theme) => ({
							m: (theme) => theme.spacing(4, 'auto', 2),
							justifyContent: 'center',
							[theme.breakpoints.down('md')]: {
								flexDirection: 'column',
								m: 0,
							},
						})}
						direction="row"
						spacing={4}
					>
						{ateliersFiltering.map(({ id, title, content, category, imageSrc }) => (
							<WorkshopCard
								key={id}
								title={title}
								content={content}
								category={category}
								imageSrc={imageSrc}
							/>
						))}
					</Grid>
					<Button
						bgColor="blue"
						color="white"
						label="Voir le programme des ateliers"
						mt={4}
						href={`${APP_BASE_URL}${DIARY_URL}`}
					/>
				</Zone>
			)}
			{remarks && (
				<Paper
					sx={(theme) => ({
						bgcolor: 'primary.main',
						borderRadius: 0,
						textAlign: 'center',
						p: (theme) => theme.spacing(16, 14),
						backgroundImage: `url(${strips})`,
						backgroundRepeat: 'round no-repeat',

						[theme.breakpoints.down('md')]: {
							p: theme.spacing(10, 3),
							backgroundRepeat: 'no-repeat',
						},
					})}
				>
					<img src={chairSun} alt="Le cycle du réemploi solidaire" />
					<Slide list={remarks} />
				</Paper>
			)}
			<Paper
				sx={(theme) => ({
					bgcolor: 'text.primary',
					borderRadius: 0,
					textAlign: 'center',
					p: (theme) => theme.spacing(10, 14),

					[theme.breakpoints.down('md')]: {
						p: theme.spacing(10, 3),
					},
				})}
			>
				<TitleSubtitle
					subtitle="La Collecterie en chiffres"
					title="depuis 2012"
					color="white"
					inverseTitle
				/>
				{figures && <Figures list={figures} />}
			</Paper>
		</>
	)
}

export default RecoveryWorkshop
